import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppClientResourcesModule, CommonLayoutModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from '../../../components/transport-options-panel/transport-options-panel.module';
import { TransportRegistrationTargetStationSelectionComponent } from './component/transport-registration-target-station-selection.component';
import { CenteredScrollableContentModule, TapableTerminalCardModule } from '@sdbn/tmc-common';



@NgModule({
  declarations: [
    TransportRegistrationTargetStationSelectionComponent,
  ],
  imports: [
    CommonModule,
    TransportOptionsPanelModule,
    CommonLayoutModule,
    AppClientResourcesModule,
    TapableTerminalCardModule,
    CenteredScrollableContentModule
  ]
})
export class TransportRegistrationTargetStationSelectionModule { }
